import { render, staticRenderFns } from "./ShDatePicker.md?vue&type=template&id=70e4bc38"
import script from "./ShDatePicker.md?vue&type=script&lang=js"
export * from "./ShDatePicker.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports